<template>
    <div class="atmo-content-group">
        <AccordionItem :visible="$route.hash === '#second-offer-contract'" title="Предложить заключить контракт второму месту" header-class="fs-22" class="atmo-hash-jump-point" id="second-offer-contract">
            <h5 class="grey-color fw-600">Информация о поставщике (второе место)</h5>
            <text-row-link compact label="Наименование" v-model="purchaseItem.second_offer.organization.full_name" :router-link="{ name: 'OrganizationShow', params: { id: purchaseItem.second_offer.organization.id } }" />
            <text-row compact label="ИНН" v-model="purchaseItem.second_offer.organization.inn" />
            <text-row compact label="КПП" v-model="purchaseItem.second_offer.organization.kpp" />
            <text-row compact label="ОГРН" v-model="purchaseItem.second_offer.organization.ogrn" />
            <text-row-single-document compact label="Карточка предприятия" v-model="purchaseItem.second_offer.organization_card_attachment" />

            <text-row compact label="Рейтинг ИС" v-model="purchaseItem.second_offer.organization.rating" />
            <text-row-documents compact v-model="purchaseItem.second_offer.documents" label="Дополнительные документы, приложенные поставщиком к предложению" />
            <offer-supplier-requirements-view :purchase-item="purchaseItem" :offer="purchaseItem.second_offer" />
            <h5 class="grey-color fw-600 pt-2">Стоимость</h5>
            <text-row-price label="Ценовое предложение второго места" :value="purchaseItem.second_offer.total_cost" compact />
            <form-row-specification-table-with-vat-view v-model="purchaseItem.second_offer.deliverables" :price-wo-vat="purchaseItem.second_offer.price_wo_vat" :total-cost="purchaseItem.second_offer.total_cost">
                <template #header>
                    <h5 class="grey-color fw-600 pt-2">Спецификация предложения</h5>
                </template>
            </form-row-specification-table-with-vat-view>
            <form-row-single-line-document-upload v-if="form.contract_attachment?.length > 0" v-model="form.contract_attachment" :label-cols-lg="3" :v="$v.form.contract_attachment" title="Контракт" />
            <limits-editable-table
                v-if="!purchaseItem.without_limits"
                v-model="form.limits"
                :total-cost="purchaseItem.second_offer.total_cost"
                @validate="limitsValidate"
                :limit-year="purchaseItem.purchase_limit_year"
                :order-type="purchaseItem.order_type"
                purchase-type="fl44"
                :purchase-id="purchaseItem.id">
                <template #title>
                    <h5 class="grey-color fw-600">Измените лимиты</h5>
                </template>
            </limits-editable-table>
            <form-row-single-line-document-upload v-model="form.contract_attachment" :label-cols-lg="3" :v="$v.form.contract_attachment" title="Контракт" />
            <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                <b-button :disabled="!isValid" variant="custom-green" class="text-uppercase ml-1" @click="storeSecondContract">Отправить контракт</b-button>
            </b-overlay>
        </AccordionItem>
    </div>
</template>

<script>
import Config from '@core/js/ddriven/application/config/Config';
import { required } from 'vuelidate/lib/validators';
import AccordionItem from '@/components/common/accordion-item.vue';
import OfferSupplierRequirementsView from '@/components/products/fl44/partials/offer-supplier-requirements-view.vue';

export default {
    name: 'send-second-offer-contract',
    components: {
        OfferSupplierRequirementsView: OfferSupplierRequirementsView,
        AccordionItem,
    },
    props: {
        purchaseItem: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.form.limits = this.purchaseItem.limits_for_second_offer_contract;
    },
    data() {
        return {
            isDataSending: false,
            isLimitsValid: false,
            form: {
                contract_attachment: null,
                limits: []
            }
        };
    },
    validations: {
        form: {
            contract_attachment: { required }
        }
    },
    methods: {
        async storeSecondContract() {
            this.isDataSending = true;
            await this.$api.personal.fl44
                .storeSecondContract(this.purchaseItem.id, this.form)
                .then((response) => {
                    if (response) {
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        limitsValidate(value) {
            this.isLimitsValid = !value;
        }
    },
    computed: {
        features() {
            return Config.get('theme.features');
        },
        isValid() {
            const kbkLimits = this.features.kbk_limits ? this.isLimitsValid || this.purchaseItem.without_limits : true;
            return kbkLimits && !this.$v.$invalid;
        }
    }
};
</script>
